import axios from "axios";
import { user, contract, callout } from "../stores/index";

// INTERCEPTING API ERRORS AND SENDING IT TO CALLOUT STORE
axios.interceptors.response.use(
  (r) => {
    if (r.data?.warnings && Array.isArray(r.data.warnings)) {
      r.data.warnings.forEach((warning) => {
        console.log(`Warning [${warning.code}]: ${warning.message}`);
      });
    }
    return r;
  },
  (e) => {
    console.log("e :", e);
    console.log("API ERROR --->", e.response);
    if (
      e.config?.url?.includes("dryRun") ||
      e.config?.url?.includes("dryrun")
    ) {
      throw e;
    } else if (e?.response?.status === 403 && e?.config?.url === "/me") {
      const errorMessage = `Access Denied (Code 403): You don't have permission to access this page.`;
      callout.set({ msg: errorMessage, status: "error", timeout: true });
      throw e;
    } else if (e?.response?.status === 403) {
      location.replace(`/forbidden`);
      throw e;
    } else if (
      e.config.method === "get" &&
      e?.response?.status === 404 &&
      !e.config.url.includes("authorizers/idp/")
    ) {
      // location.replace(`/404`);
      throw e;
    } else if (!e?.config?.url.includes("dryRun")) {
      const errorMessage = e?.response?.data?.message
        ? `Error: ${e.response.data.message}`
        : (e?.message ?? "An unexpected error occurred");
      callout.set({ msg: errorMessage, status: "error", timeout: true });
      throw e;
    } else {
      throw e;
    }
  },
);

class API {
  constructor() {
    this.contractid = null;
    contract.subscribe((contract) => {
      this.contractid = contract ? contract.id : null;
    });
  }

  init({ apiurl }) {
    this.url = `${apiurl}/access-manager/api/v1/`;
  }

  async getToken() {
    let token;
    user.subscribe((user) => {
      token = user ? user.token : null;
    });

    return token ? `${token.type} ${token.token}` : null;
  }

  async request({ method, url, data, config = {} }) {
    const response = await axios.request({
      method,
      baseURL: this.url,
      url,
      data,
      ...config,
      headers: {
        Authorization: await this.getToken(),
        "gl-contract-id": this.contractid,
        ...(config.headers || {}),
      },
    });
    return response.data;
  }

  async get(url, config) {
    return await this.request({ method: "get", url, config });
  }

  async post(url, data, config) {
    return await this.request({ method: "post", url, data, config });
  }

  async put(url, data, config) {
    return await this.request({ method: "put", url, data, config });
  }

  async patch(url, data, config) {
    return await this.request({ method: "patch", url, data, config });
  }

  async delete(url, data, config) {
    return await this.request({ method: "delete", url, data, config });
  }
}

export default API;
